import localforage from 'localforage';

const version = 'rtgrtg766ryt535';
const dbName = 'StateDB';
const lf = localforage;

lf.config({
  name: dbName,
});

export {
  lf, version, dbName,
};

// https://tutorialzine.com/2017/05/quick-tip-make-indexed-db-a-breeze-with-local-forage
